import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LtAutocompleteComponent } from './components/lt-autocomplete/lt-autocomplete.component';
import { LtAutocompleteTComponent } from './components/lt-autocomplete-t/lt-autocomplete-t.component';
import { LTMultiColumnComboBoxComponent } from './components/lt-multicolumn-combobox/lt-multicolumn-combobox.component';
@NgModule({
  imports: [
    CommonModule,
    LtAutocompleteComponent,
    LtAutocompleteTComponent,
    LTMultiColumnComboBoxComponent,
  ],
  exports: [
    LtAutocompleteComponent,
    LtAutocompleteTComponent,
    LTMultiColumnComboBoxComponent,
  ],
})
export class LTAutoCompleteModule { }